import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import StyleSheet from 'styles'
import Table, { TableHead, TableBody, TableRow, TableCell } from 'components/CollapsibleTable'
import { ImageAvatar } from 'components'
import { StatusTag } from 'components/deal_sheet'

const ROI_TABLE_BREAKPOINT = 700

export class RoiTable extends Component {
  static propTypes = {
    deals: PropTypes.array.isRequired
  }

  static defaultProps = {
    deals: []
  }


  /**
   * #TODO
   * Calculate the ROI between the public sale rate and the current market/exchange spot-rate
   */
  roiStatus({roi, currentPriceFormatted, currency}){
    return {
      increase: roi > 0,
      value: `${currentPriceFormatted}${this.currencyCode({currency})}`,
      change: `${Math.abs(roi)}%`
    }
  }

  currencyCode({currency}){
    return currency && currency.code
  }

  renderAvatar = (deal) => {
    const { issuerAccountName, emblemUrls } = deal
    return <ImageAvatar alt={ issuerAccountName } urls={ emblemUrls }/>
  }

  renderDealStatus = (deal) => {
    const { status } = deal
    return (
      <StatusTag status={ status } className={ styles.statusTag } />
    )
  }

  renderRoi = (deal) =>  {
    const status = this.roiStatus(deal)
    return deal.roi ? (
      <span className={styles('roiPercentageChange', {roiUpwards: status.increase, roiDownwards: !status.increase})}>
        {status.change}
      </span>
    ) : false
  }
  renderDeal = (deal) => {
    let { id, name, saleCap, amountRaised, icoPriceFormatted, currentPriceFormatted } = deal
    let title = name
    amountRaised    = parseFloat(amountRaised) || 0
    saleCap         = parseFloat(saleCap) || 0
    return (
      <TableRow key={ id } className={ styles.row }>
        <TableCell mobileHeading>
          <div className={ styles.avatar }>
            { this.renderAvatar(deal) }
            <Typography variant='subtitle1' className={ styles.tagLine }>{ title }</Typography>
          </div>
        </TableCell>
        <TableCell mobileLabel="Raised Level">
          <div className={styles.barOuter}>
            <div style={{width: `${100 * (amountRaised / saleCap)}%`}} className={styles('barInner', {filled: amountRaised >= saleCap})}>
            </div>
          </div>
        </TableCell>
        <TableCell mobileLabel="Raised Amount">
          {
            !!amountRaised &&
            amountRaised.toFixed(3)+this.currencyCode(deal)
          }
        </TableCell>
        <TableCell mobileLabel="ICO Price">
          {icoPriceFormatted}
        </TableCell>
        <TableCell mobileLabel="Current Price">
          {currentPriceFormatted}
        </TableCell>
        <TableCell mobileLabel="ROI">
          {this.renderRoi(deal)}
        </TableCell>
      </TableRow>
    )
  }

  render = () => {
    return (
      <div className={styles.list}>
        <Table breakpoint={ROI_TABLE_BREAKPOINT}>
          <TableHead>
            <TableRow>
              <TableCell>Deals</TableCell>
              <TableCell>Raised Level</TableCell>
              <TableCell>Raised Amount</TableCell>
              <TableCell>ICO Price</TableCell>
              <TableCell>Current Price</TableCell>
              <TableCell>ROI</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.deals.map(deal =>
              this.renderDeal(deal)
            )}
          </TableBody>
        </Table>
      </div>
    )
  }
}

const styles = StyleSheet({
  list: {
    paddingTop: 8,
    width: '100%'
  },
  avatar: {
    display: 'flex',
    alignItems: 'center'
  },
  tagLine: {
    paddingLeft: 8,
    fontSize: '16px',
    fontWeight: 700,
    color: '#464646'
  },
  barOuter: {
    width: 130,
    background: 'silver',
    height: 8,
    borderRadius: 15,
    overflow: 'hidden',
    [`@media(max-width: ${ROI_TABLE_BREAKPOINT + 50}px)`]: {
      width: 'auto',
      marginRight: 20,
      position: 'relative',
      left: 20
    }
  },
  barInner: {
    height: 8,
    borderRadius: 15,
    background: '#666',
    width: 50
  },
  filled: {
    background: '#8BC911'
  },
  roiPercentageChange: {
    flex: 0,
    fontSize: 16,
    fontWeight: 700
  },
  roiUpwards: {
    color: '#90c814'
  },
  roiDownwards: {
    color: '#f72d1c'
  },
  dealStatus: {},
  statusTag: {},
  dealStatusCollapsed: {
    '& $statusTag':{
      float: 'left'
    }
  },
  expandHandler: {},
  expandHandlerCollapsed: {
    '& $expandHandler':{
      left: '-16px'
    }
  }
})

export default RoiTable